var map = {
	"./casino/router/routes.js": "FUNv",
	"./default/router/routes.js": "2sV6",
	"./marketmaker/router/routes.js": "N1uL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PqhA";


//////////////////
// WEBPACK FOOTER
// ./src/companies ^\.\/.*\/router\/routes\.js$
// module id = PqhA
// module chunks = 1